export default {
  template: '#vue-overlay',
  delimiters: ['${', '}'],
  data: function () {
    return {
      modal_body: null,
      modal_class: null,
      modal_class_body: null,
      type: null,
      stores: [],
      item: {},
      image: {}
    }
  },
  created() {
    this.$store.commit("registerComponent", {name: 'overlay', component: this})
  },
  computed: {},
  methods: {
    hideOverlay: function () {
      document.body.removeAttribute('class');
      this.$store.commit({
        type: 'setFlyout',
        value: false
      });
      // document.getElementById("filters-flyout").classList.remove("active");
    },
    stopPropagation: function (e) {
      e.stopPropagation();
    },
    handleClick: function (e) {
      if (e.target.matches('.js-hide-overlay')) {
        this.hideOverlay();
      }
    },
    openModal(data) {
      this.type = data.modal;
      this.modal_class = 'c-modal--' + data.modal;
      this.modal_class_body = 'c-modal__body--' + data.modal;
      if (this.type === 'image-modal') {
        this.image = {src: data.src, alt: data.alt}
      } else {
        this.image = null
      }
      if (!['pickup', 'image-modal', '3d-modal'].includes(this.type)) {
        this.modal_body = document.querySelector(`#modal-body-${data.modal}`).innerHTML;
      } else if (data.stores) {
        this.stores = data.stores;
        this.item = data.item;
      }
      document.body.setAttribute('class', 'c-body--overlay');
    }
  }
}